export default {
  bankList: [],
  regionCountry: {},
  cityList: [],
  areaList: [],
  regionList: [],
}
